(()=>{const polish=()=>{const el=document.querySelector('.product-info h1.product-title,h1.product-title');if(el&&!el.dataset.polished){let t=el.textContent.trim();t=t.replace(/^NEW\s*[-–—]\s*/i,'').replace(/\s*[-–—]\s*MICHAL ART STUDIO HAWAII.*$/i,'').replace(/\s*[-–—]\s*ORIGINAL PAINTING\s*/i,' — Original Painting ').replace(/\s*[-–—]\s*THE NEWEST ORIGINAL HAWAIIAN TROPICAL FLORAL PAINTING/i,' — Original Painting').replace(/\s+RARE ORIGINALS/i,'').replace(/\s*[-–—]\s*THE PINK SERIES/i,' — Pink Series').replace(/(\d+)\s*[xX]\s*(\d+)/g,'$1 × $2').replace(/\s+/g,' ').trim();el.textContent=t;el.dataset.polished='true'}document.querySelectorAll('[data-block-type="buy-buttons"] button[type="submit"]').forEach(b=>{for(const n of b.childNodes){if(n.nodeType===3&&/add to cart/i.test(n.nodeValue||''))n.nodeValue='ADD TO BAG'}})};document.addEventListener('DOMContentLoaded',()=>{polish();setTimeout(polish,500);setTimeout(polish,1500)});new MutationObserver(polish).observe(document.documentElement,{childList:true,subtree:true})})();
;(()=>{
  const FORMAT_SIZES={
    "Matted Paper Print":["8 × 10 in art · 11 × 14 in mat"],
    "Large Paper Print":["20 × 28 in"],
    "Rolled Canvas":["11 × 14 in","16 × 20 in","30 × 40 in","50 × 60 in"],
    "Stretched Canvas":["11 × 14 in","16 × 20 in"]
  };
  const clean=t=>(t||"").replace(/\s*(Sold out|Unavailable)\s*$/i,"").trim();
  const labelFor=(field,input)=>input?.id?field.querySelector('label[for="'+CSS.escape(input.id)+'"]'):null;
  const selectedText=field=>{
    const checked=field.querySelector("input:checked");
    const label=labelFor(field,checked);
    if(label)return clean(label.querySelector("span")?.textContent||label.textContent);
    const shown=field.querySelector(".select span[id$='selected-value']");
    return clean(shown?.textContent);
  };
  const optionText=node=>clean(node.querySelector("span")?.textContent||node.textContent);
  const updatePicker=picker=>{
    const title=document.querySelector(".product-info h1.product-title,h1.product-title")?.textContent||"";
    if(!/Fine Art Print/i.test(title))return;
    const fields=[...picker.querySelectorAll("fieldset")];
    const mediumField=fields.find(f=>/^Medium\s*:/i.test(f.querySelector("legend")?.textContent||""));
    const sizeField=fields.find(f=>/^Size\s*:/i.test(f.querySelector("legend")?.textContent||""));
    if(!mediumField||!sizeField)return;
    const medium=selectedText(mediumField);
    const allowed=FORMAT_SIZES[medium]||[];
    const choices=[...sizeField.querySelectorAll(".variant-picker__option-values > label,.popover__value-option")];
    let firstAllowed=null,selectedAllowed=false;
    choices.forEach(choice=>{
      const value=optionText(choice);
      const show=allowed.includes(value);
      choice.hidden=!show;
      choice.style.display=show?"":"none";
      choice.setAttribute("aria-hidden",show?"false":"true");
      const input=choice.htmlFor?document.getElementById(choice.htmlFor):choice.querySelector("input");
      if(show&&!firstAllowed)firstAllowed={choice,input};
      if(show&&input?.checked)selectedAllowed=true;
    });
    if(allowed.length&&firstAllowed&&!selectedAllowed&&!picker.dataset.michalAdjusting&&firstAllowed.input){
      picker.dataset.michalAdjusting="true";
      setTimeout(()=>{firstAllowed.input.click();setTimeout(()=>delete picker.dataset.michalAdjusting,250)},20);
    }
  };
  const updateAll=()=>document.querySelectorAll("variant-picker").forEach(updatePicker);
  document.addEventListener("change",()=>setTimeout(updateAll,40));
  document.addEventListener("DOMContentLoaded",()=>{updateAll();setTimeout(updateAll,500);setTimeout(updateAll,1400)});
  new MutationObserver(()=>requestAnimationFrame(updateAll)).observe(document.documentElement,{childList:true,subtree:true});
})();